import api from '@/api';

const resource = 'merenda/composicao-preparacao';

export default {
  inserirComposicaoPreparacao(data) {
    return api.post( `${resource}`, data );
  },

  editarComposicaoPreparacao( data ) {
    return api.put( `${resource}/${data.identificadorcomposicaoalimento}`, data);
  },

  deletarComposicaoPreparacao( identificadorcomposicaoalimento ) {
    return api.delete(`${resource}/${identificadorcomposicaoalimento}`);
  },

  buscarComposicaoPreparacao(identificadorpreparacao) {
    return api.get( `${resource}/${identificadorpreparacao}` );
  }
};
